export const jwtDecode = (token) => JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
//# sourceMappingURL=jwt.js.map